<template>
  <div id="add_content">
    <Navbar
      linkName="Conteúdos"
      :link="$paths.contents.categories.list"
      current="Novo conteúdo"
      :sublink="`${$paths.contents.list}/${parentCategory?.id}`"
      :sublinkName="parentCategory?.name"
    />
    <Sidebar />
    <Container>
      <Header title="Novo conteúdo"> </Header>
      <div class="card">
        <LoadingContainer v-if="loading" />
        <div v-else>
          <div class="card-body">
            <h2 class="text-header">Local de criação</h2>
            <TextInput readOnly label="Local" :value="parentCategory?.name">
              <template v-slot:labelContentEnd>
                <router-link
                  :to="`${$paths.contents.list}/${parentCategory?.id}`"
                  >Ver itens</router-link
                >
              </template>
            </TextInput>
          </div>

          <hr class="my-0" />

          <div class="card-body">
            <h2 class="text-header">Título</h2>

            <TextInput
              label="Título"
              :model="$v.form.name"
              placeholder="Insira o titulo do conteúdo"
            />

            <!-- <TextAreaInput
              :model="$v.form.description"
              label="Descrição"
              placeholder="Insira a descrição do conteúdo"
              class="mb-3"
            /> -->

            <label class="form-label text-muted">Conteúdo</label>
            <div class="form-check form-switch d-flex ps-0">
              <label class="form-check-label" for="isPremium"
                >Conteúdo exclusivo para assinantes
              </label>
              <!-- // TODO: Fazer vir o valor correto nesse switch quando for pra editar -->
              <input
                @click="setPremiumContent"
                v-model="$v.form.only_subscribers"
                class="form-check-input ms-3"
                type="checkbox"
                role="switch"
                id="isPremium"
              />
            </div>
          </div>

          <!-- <hr class="my-0" />

          <div class="card-body">
            <SelectInput
              label="Tipo de hyperlink"
              :hasDefaultValue="true"
              propertyForText="name"
              :model="$v.form.hyperlink_type"
              :options="hyperlink_types"
            />
          </div> -->

          <hr class="my-0" />

          <!-- ADD CONTENT CONTAINER-->
          <div class="card-body">
            <h2 class="text-header">Conteúdo</h2>

            <!-- CONTENTS -->
            <div
              v-for="(item, index) in $v.form.items.$each.$iter"
              v-bind:key="'text_' + index"
            >
              <div class="row">
                <div class="col-12 col-md-10">
                  <p class="text-subtitle">
                    <i
                      class="text-primary"
                      :class="getTypeIcon(item.type.$model)"
                    ></i>
                    {{ getTypeLabel(item.type.$model) }}
                  </p>
                </div>
                <div class="col-12 col-md-2 text-end">
                  <button
                    class="btn btn-sm btn-del"
                    @click.prevent="removeContent(index)"
                  >
                    Remover
                  </button>
                </div>
              </div>

              <!-- SELECT TAB AND SORT BUTTON -->
              <div class="row">
                <div class="col">
                  <SelectInput
                    label="Aba"
                    :hasDefaultValue="true"
                    propertyForText="name"
                    @selectChanged="($event) => selectTab($event, index)"
                    :model="item.tab_id"
                    :options="tabs"
                  />
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-outline-primary btn-lg text-subtitle"
                    style="margin-top: 28px"
                    data-bs-toggle="modal"
                    data-bs-target="#sort_items"
                    @click="
                      setupSortItems(item.tab_id.$model, item.fakeId.$model)
                    "
                  >
                    Alterar ordem
                    <i class="fa-solid fa-arrow-up-wide-short"></i>
                  </button>
                </div>
              </div>

              <!-- TEXT INPUT -->
              <TextInput
                label="Título"
                :model="item.name"
                placeholder="Insira o titulo do conteúdo"
              />

              <!-- DESCRIPTION INPUT -->
              <TextAreaInput
                v-if="item.type.$model != 'html'"
                label="Descrição"
                placeholder="Insira a descrição do conteúdo"
                :model="item.description"
                class="mb-4"
              />

              <!-- CUSTOM DESCRIPTION INPUT -->
              <label
                class="form-label text-muted"
                v-if="item.type.$model == 'html'"
                >Descrição</label
              >
              <EditorInput
                v-if="item.type.$model == 'html'"
                :model="item.description"
                style="height: calc(30vh)"
              />

              <!-- VIDEO INPUT -->
              <div v-if="item.type.$model == 'video'">
                <label class="form-label text-muted"> Video </label>
                <div class="input-group mb-3">
                  <span class="input-group-text">
                    <i class="fa-solid fa-photo-video"></i>
                  </span>

                  <input
                    @input="setIframe($event, index)"
                    type="text"
                    class="form-control form-control-lg"
                    v-model="item.url.$model"
                    placeholder="www.youtube.com.br/8dS912kdsa9"
                  />
                </div>

                <iframe
                  class="mb-2"
                  v-if="item.url.$model"
                  width="100%"
                  height="500"
                  :src="item.url.$model"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style="border-radius: 15px"
                ></iframe>

                <div class="form-check form-switch d-flex ps-0">
                  <label class="form-check-label" for="isShort">Shorts </label>
                  <!-- // TODO: Fazer vir o valor correto nesse switch quando for pra editar -->
                  <input
                    @click="setShortVideoContent(index)"
                    v-model="item.short"
                    class="form-check-input ms-3"
                    type="checkbox"
                    role="switch"
                    id="isShort"
                  />
                </div>
              </div>

              <!-- IMAGE INPUT -->
              <div v-if="item.type.$model == 'image'">
                <label class="form-label text-muted">Imagem</label>

                <ImageCropper
                  v-on:cropEnd="cropEnd($event, index)"
                  :index="index"
                />
              </div>

              <!-- CALCULATOR INPUT -->
              <div v-if="item.type.$model == 'calculator'">
                <SelectInput
                  label="Formula"
                  placeholder="Selecione a formula"
                  @selectChanged="
                    ($event) => selectCalculatorType($event, index)
                  "
                  propertyForText="name"
                  propertyForValue="key"
                  :model="item.calculator_type"
                  :options="calculatorTypes"
                />
              </div>

              <!-- SCORE INPUT -->
              <div v-if="item.type.$model == 'score'">
                <SelectInput
                  label="Formula"
                  placeholder="Selecione a formula"
                  :model="item.score_id"
                  :options="[]"
                />
              </div>

              <hr class="my-5" />
            </div>

            <!-- ADD CONTENT BUTTONS-->
            <div class="border border-primary p-4 rounded">
              <p class="text-subtitle">Adicionar conteúdo</p>
              <p>Selecione abaixo um novo tipo de conteúdo para adicionar</p>
              <div class="d-flex flex-wrap">
                <div
                  v-for="(item, index) in contentTypes"
                  :key="index"
                  class="add-content me-3 cursor-pointer"
                  @click="addContent(item.type)"
                >
                  <div
                    class="bg-primary-soft add-content-card d-flex justify-content-center align-items-center mb-2"
                  >
                    <i class="text-primary fa-3x" :class="item.icon"></i>
                  </div>
                  <p class="text-subtitle text-primary text-center">
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <hr class="my-0" />

          <div class="card-body">
            <FormButton
              label="Concluir novo conteúdo"
              :loading="submitting"
              @onClick="submit"
              :disabled="$v.$invalid"
            />
          </div>
        </div>
      </div>
    </Container>
    <ModalComponent id="sort_items" title="Alterar ordem">
      <template v-slot:body>
        <ul class="nav nav-tabs nav-overflow mb-4">
          <li class="nav-item" v-for="(item, index) of tabs" v-bind:key="index">
            <a
              href="#"
              @click.prevent="setupSortItems(item.id)"
              class="nav-link text-subtitle pt-0"
              :class="{ active: item.active, 'text-primary': item.active }"
            >
              {{ item.name }}
            </a>
          </li>
        </ul>

        <draggable
          class="list-group list-group-sm mb-4"
          v-model="sortItems[currentTab?.name]"
          @start="drag = true"
          @end="drag = false"
          @change="changeOrder"
        >
          <li
            v-for="(element, index) in sortItems[currentTab?.name]"
            :key="element.id"
            class="list-group-item d-flex justify-content-between align-items-center cursor-move"
          >
            <div>
              <strong> {{ index }}º </strong>
              <strong v-if="element.fakeId == currentItem">
                {{ element.name }} - Selecionado
              </strong>
              <span v-else>{{ element.name }} </span>
            </div>
            <i class="fa-solid fa-bars text-muted"></i>
          </li>
        </draggable>
        <div class="d-flex justify-content-end">
          <button class="btn btn-primary align-self-end" @click="handleSort">
            <span class="text-action"> Concluir </span>
          </button>
        </div>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import AddContentController from "./AddContentController";
export default AddContentController;
</script>

<style>
.add-content {
  width: 105px;
}

.add-content-card {
  width: 105px;
  height: 105px;
  border-radius: 10px;
}
</style>
